'use es6';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentRowInsertTargetInfo, getCurrentColumnInsertTargetInfo, getDragItemIsHidden } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { VerticalInsertDropTarget, HorizontalInsertDropTarget } from 'layout-dnd-components/InsertDropTargets';
import { dropTargetLocations } from 'InpageEditorUI/lib/layoutSection/constants';
import { SHADE_BOTH } from 'layout-dnd-components/InsertDropTargets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  BEFORE,
  AFTER,
  SPLIT_ROW_BEFORE,
  SPLIT_ROW_AFTER
} = dropTargetLocations;
const SHADE_THICKNESS = 20;
const mapStateToProps = state => {
  return {
    rowDropTargetInfo: getCurrentRowInsertTargetInfo(state),
    columnDropTargetInfo: getCurrentColumnInsertTargetInfo(state),
    dragItemIsHidden: getDragItemIsHidden(state)
  };
};
const renderColumnDropTarget = columnDropTargetInfo => {
  if (columnDropTargetInfo) {
    const {
      top,
      left,
      height,
      width,
      type,
      shade
    } = columnDropTargetInfo;
    if (type === BEFORE || type === AFTER) {
      return /*#__PURE__*/_jsx(VerticalInsertDropTarget, {
        top: Math.round(top),
        left: Math.round(left),
        height: Math.round(height),
        shade: shade,
        shadeThickness: 0,
        ballRadius: 9
      });
    } else if (type === SPLIT_ROW_BEFORE || type === SPLIT_ROW_AFTER) {
      return /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
        top: Math.round(top),
        left: Math.round(left),
        width: Math.round(width),
        shade: shade,
        shadeThickness: shade === SHADE_BOTH ? 0 : SHADE_THICKNESS,
        ballRadius: 9
      });
    }
  }
  return null;
};
const renderRowDropTarget = rowDropTargetInfo => {
  if (rowDropTargetInfo) {
    const {
      top,
      left,
      width,
      shade
    } = rowDropTargetInfo;
    return /*#__PURE__*/_jsx(HorizontalInsertDropTarget, {
      top: Math.round(top),
      left: Math.round(left),
      width: Math.round(width),
      shade: shade,
      shadeThickness: shade === SHADE_BOTH ? 0 : SHADE_THICKNESS,
      ballRadius: 9
    });
  }
  return null;
};
const LayoutSectionDropTargetsContainer = ({
  rowDropTargetInfo,
  columnDropTargetInfo,
  dragItemIsHidden
}) => {
  if (!dragItemIsHidden) {
    return /*#__PURE__*/_jsxs("div", {
      children: [renderColumnDropTarget(columnDropTargetInfo), renderRowDropTarget(rowDropTargetInfo)]
    });
  }
  return null;
};
LayoutSectionDropTargetsContainer.propTypes = {
  rowDropTargetInfo: PropTypes.object,
  columnDropTargetInfo: PropTypes.object,
  dragItemIsHidden: PropTypes.bool
};
export default connect(mapStateToProps)(LayoutSectionDropTargetsContainer);